import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

import { InterceptorLoginComponent } from '../pages/auth/interceptor-login/interceptor-login.component';
import { AUTH_PATHS } from '../pages/auth/auth';
import { isLegacyLoginEnabled } from '../../environments/legacy-login';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private cookieService: CookieService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.cookieService.get('csrftoken')) {
      request = request.clone({
        headers: request.headers.set('X-CSRFToken', this.cookieService.get('csrftoken')),
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.router.url === '/' + AUTH_PATHS.login || this.router.url.indexOf('/' + AUTH_PATHS.login_callback) === 0) {
          return throwError(error);
        }

        if ([401].indexOf(error.status) > -1 && request.method === 'POST' && isLegacyLoginEnabled()) {
          this.cookieService.delete('csrftoken');

          return this.openAuthDialog(error).pipe(
            switchMap(() => {
              if (this.cookieService.get('csrftoken')) {
                request = request.clone({
                  headers: request.headers.set('X-CSRFToken', this.cookieService.get('csrftoken')),
                });
              }

              return next.handle(request);
            })
          );
        } else if ([401].indexOf(error.status) > -1) {
          this.cookieService.delete('csrftoken');
          this.redirectToAuth();

          return throwError(error);
        } else {
          return throwError(error);
        }
      })
    );
  }

  openAuthDialog(authError: HttpErrorResponse) {
    return new Observable<any>((observer) => {
      this.modalService
        .open(InterceptorLoginComponent, {
          ariaLabelledBy: 'modal-basic-title',
          windowClass: 'modal-wrapper',
          backdrop: 'static',
        })
        .result.then(
          (data) => {
            observer.next(data);
            observer.complete();
          },
          () => {
            this.redirectToAuth();
            observer.error(authError);
          }
        );
    });
  }

  redirectToAuth() {
    this.router.navigate(['/' + (isLegacyLoginEnabled() ? AUTH_PATHS.login_legacy : AUTH_PATHS.login)], {
      queryParams: { url: this.router.url },
    });
  }
}
